'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAssignedAgentType = exports.getAssignedAgentId = exports.getAssignedByAgentId = exports.getAssignedByAgentType = exports.getAssignedByMethod = exports.getAgentId = exports.getAgentType = undefined;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _keyPaths = require('./keyPaths');

var _keyPaths2 = _interopRequireDefault(_keyPaths);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getAgentType = exports.getAgentType = (0, _getIn2.default)(_keyPaths2.default.AGENT_TYPE);

var getAgentId = exports.getAgentId = (0, _getIn2.default)(_keyPaths2.default.AGENT_ID);

var getAssignedByMethod = exports.getAssignedByMethod = (0, _getIn2.default)(_keyPaths2.default.ASSIGNED_BY_METHOD);

var getAssignedByAgentType = exports.getAssignedByAgentType = (0, _getIn2.default)(_keyPaths2.default.ASSIGNED_BY_AGENT_TYPE);

var getAssignedByAgentId = exports.getAssignedByAgentId = (0, _getIn2.default)(_keyPaths2.default.ASSIGNED_BY_AGENT_ID);

var getAssignedAgentId = exports.getAssignedAgentId = (0, _getIn2.default)(_keyPaths2.default.ASSIGNED_AGENT_ID);

var getAssignedAgentType = exports.getAssignedAgentType = (0, _getIn2.default)(_keyPaths2.default.ASSIGNED_AGENT_TYPE);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/operators/assignment-message/getters.js
// module id = 413
// module chunks = 2 3